import { useState, useEffect } from 'react';
import { servicesPageService } from '@/api/services';

// Icon mapping - maps icon names from DB to React icon components
// Curated set of icons for travel/tourism and business services
// Icons from react-icons/fa
import { 
  // Travel & Transportation
  FaBed, FaPlane, FaPlaneArrival, FaPlaneDeparture, FaBus, FaBusAlt, FaCar, FaTaxi, FaTrain, FaShip, FaBicycle, FaWalking,
  // Accommodation & Facilities
  FaHotel, FaSwimmingPool, FaSpa, FaUtensils, FaCoffee, FaWineGlass, FaCocktail,
  // Activities & Attractions
  FaUmbrellaBeach, FaMountain, FaMonument, FaLandmark, FaCamera, FaImage, FaVideo, FaMusic,
  // People & Groups
  FaUsers, FaUserFriends, FaBaby, FaUsersCog,
  // Business & Services
  FaClipboardCheck, FaHeadset, FaPhone, FaEnvelope, FaGlobe, FaLanguage, FaFlag,
  FaCalendar, FaCalendarAlt, FaCalendarCheck, FaClock,
  FaMapMarkerAlt, FaMap, FaRoute, FaCompass, FaNetworkWired, FaProjectDiagram, FaSitemap,
  // General
  FaStar, FaHeart, FaAward, FaTrophy, FaGift, FaCreditCard, FaShoppingBag, FaShoppingCart
} from 'react-icons/fa';

// Icons from react-icons/fa6
import { 
  // Travel & Transportation
  FaSuitcaseRolling, FaCarRear, FaCarSide, FaVanShuttle, FaTruck,
  // People & Groups
  FaUsersGear, FaPeopleLine, FaUserGroup, FaUserTie, FaUserCheck, FaPeopleGroup,
  // Business & Services
  FaHandshakeSimple, FaRegHandshake, FaRegLightbulb, FaMapLocationDot, FaLocationPin, FaLocationDot,
  FaArrowTrendUp, FaScaleBalanced,
  // Activities
  FaPersonSwimming, FaPersonRunning, FaPersonBiking, FaPersonHiking,
  FaMountainSun, FaWaterLadder
} from 'react-icons/fa6';

// Icons from react-icons/bs (Bootstrap Icons)
import {
  // Time & Alerts
  BsFillStopwatchFill, BsFillLightningFill, BsClock, BsClockFill, BsAlarm, BsAlarmFill,
  // Security & Safety
  BsShieldFillCheck, BsShieldCheck, BsShieldLock, BsShieldLockFill, BsShield, BsShieldFill,
  // General
  BsCheckCircle, BsCheckCircleFill, BsXCircle, BsXCircleFill, BsInfoCircle, BsInfoCircleFill,
  BsExclamationCircle, BsExclamationCircleFill, BsQuestionCircle, BsQuestionCircleFill,
  BsStar, BsStarFill, BsHeart, BsHeartFill, BsBookmark, BsBookmarkFill,
  // Navigation & Location
  BsGeoAlt, BsGeoAltFill, BsMap, BsMapFill, BsCompass, BsCompassFill,
  // Communication
  BsTelephone, BsTelephoneFill, BsEnvelope, BsEnvelopeFill, BsChat, BsChatFill,
  // Business & Services
  BsBriefcase, BsBriefcaseFill, BsBuilding, BsBuildingFill, BsShop, BsShopWindow,
  // People
  BsPeople, BsPeopleFill, BsPerson, BsPersonFill, BsPersonCheck, BsPersonCheckFill
} from 'react-icons/bs';

const iconMap = {
  // Travel & Transportation (react-icons/fa)
  FaBed, FaPlane, FaPlaneArrival, FaPlaneDeparture, FaBus, FaBusAlt, FaCar, FaTaxi, FaTrain, FaShip, FaBicycle, FaWalking,
  // Accommodation & Facilities (react-icons/fa)
  FaHotel, FaSwimmingPool, FaSpa, FaUtensils, FaCoffee, FaWineGlass, FaCocktail,
  // Activities & Attractions (react-icons/fa)
  FaUmbrellaBeach, FaMountain, FaMonument, FaLandmark, FaCamera, FaImage, FaVideo, FaMusic,
  // People & Groups (react-icons/fa)
  FaUsers, FaUserFriends, FaBaby, FaUsersCog,
  // Business & Services (react-icons/fa)
  FaClipboardCheck, FaHeadset, FaPhone, FaEnvelope, FaGlobe, FaLanguage, FaFlag,
  FaCalendar, FaCalendarAlt, FaCalendarCheck, FaClock,
  FaMapMarkerAlt, FaMap, FaRoute, FaCompass, FaNetworkWired, FaProjectDiagram, FaSitemap,
  // General (react-icons/fa)
  FaStar, FaHeart, FaAward, FaTrophy, FaGift, FaCreditCard, FaShoppingBag, FaShoppingCart,
  // Travel & Transportation (react-icons/fa6)
  FaSuitcaseRolling, FaCarRear, FaCarSide, FaVanShuttle, FaTruck,
  // People & Groups (react-icons/fa6)
  FaUsersGear, FaPeopleLine, FaUserGroup, FaUserTie, FaUserCheck, FaPeopleGroup,
  // Business & Services (react-icons/fa6)
  FaHandshakeSimple, FaRegHandshake, FaRegLightbulb, FaMapLocationDot, FaLocationPin, FaLocationDot,
  FaArrowTrendUp, FaScaleBalanced,
  // Activities (react-icons/fa6)
  FaPersonSwimming, FaPersonRunning, FaPersonBiking, FaPersonHiking,
  FaMountainSun, FaWaterLadder,
  // Time & Alerts (react-icons/bs)
  BsFillStopwatchFill, BsFillLightningFill, BsClock, BsClockFill, BsAlarm, BsAlarmFill,
  // Security & Safety (react-icons/bs)
  BsShieldFillCheck, BsShieldCheck, BsShieldLock, BsShieldLockFill, BsShield, BsShieldFill,
  // General (react-icons/bs)
  BsCheckCircle, BsCheckCircleFill, BsXCircle, BsXCircleFill, BsInfoCircle, BsInfoCircleFill,
  BsExclamationCircle, BsExclamationCircleFill, BsQuestionCircle, BsQuestionCircleFill,
  BsStar, BsStarFill, BsHeart, BsHeartFill, BsBookmark, BsBookmarkFill,
  // Navigation & Location (react-icons/bs)
  BsGeoAlt, BsGeoAltFill, BsMap, BsMapFill, BsCompass, BsCompassFill,
  // Communication (react-icons/bs)
  BsTelephone, BsTelephoneFill, BsEnvelope, BsEnvelopeFill, BsChat, BsChatFill,
  // Business & Services (react-icons/bs)
  BsBriefcase, BsBriefcaseFill, BsBuilding, BsBuildingFill, BsShop, BsShopWindow,
  // People (react-icons/bs)
  BsPeople, BsPeopleFill, BsPerson, BsPersonFill, BsPersonCheck, BsPersonCheckFill
};

/**
 * Hook to fetch and manage services page data
 * @param {string} sectionKey - Optional section key to fetch a specific section
 * @returns {object} { sections, section, loading, error }
 */
export const useServicesPage = (sectionKey = null) => {
  const [sections, setSections] = useState([]);
  const [section, setSection] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        if (sectionKey) {
          // Fetch specific section by key
          const response = await servicesPageService.getSectionByKey(sectionKey);
          if (response.data?.success) {
            const sectionData = response.data.data;
            // Map icon names to components
            if (sectionData.items) {
              sectionData.items = sectionData.items.map(item => ({
                ...item,
                IconComponent: item.icon ? iconMap[item.icon] : null
              }));
            }
            if (sectionData.content?.buttons) {
              sectionData.content.buttons = sectionData.content.buttons.map((button) => ({
                ...button,
                IconComponent: button.icon ? iconMap[button.icon] : null
              }));
            }
            if (sectionData.content?.button) {
              sectionData.content.button = {
                ...sectionData.content.button,
                IconComponent: sectionData.content.button.icon ? iconMap[sectionData.content.button.icon] : null
              };
            }
            setSection(sectionData);
          }
        } else {
          // Fetch all sections
          const response = await servicesPageService.getAllSections();
          if (response.data?.success) {
            const sectionsData = response.data.data || [];
            // Map icon names to components for all sections
            const mappedSections = sectionsData.map(sec => ({
              ...sec,
              items: sec.items?.map(item => ({
                ...item,
                IconComponent: item.icon ? iconMap[item.icon] : null
              })) || [],
              content: sec.content?.buttons
                ? {
                    ...sec.content,
                    buttons: sec.content.buttons.map((button) => ({
                      ...button,
                      IconComponent: button.icon ? iconMap[button.icon] : null
                    })),
                    ...(sec.content?.button
                      ? {
                          button: {
                            ...sec.content.button,
                            IconComponent: sec.content.button.icon ? iconMap[sec.content.button.icon] : null
                          }
                        }
                      : {})
                  }
                : sec.content?.button
                ? {
                    ...sec.content,
                    button: {
                      ...sec.content.button,
                      IconComponent: sec.content.button.icon ? iconMap[sec.content.button.icon] : null
                    }
                  }
                : sec.content
            }));
            setSections(mappedSections);
          }
        }
      } catch (err) {
        console.error('Error fetching services page data:', err);
        setError(err.message || 'Failed to load services page data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [sectionKey]);

  return { sections, section, loading, error };
};

/**
 * Get a specific section from the sections array by key
 * @param {array} sections - Array of sections
 * @param {string} key - Section key
 * @returns {object|null} Section object or null
 */
export const getSectionByKey = (sections, key) => {
  return sections.find(sec => sec.section_key === key) || null;
};

export default useServicesPage;

